<template>
<div :class="`wrapper  wrapper--200 m-3 p-2`">
    <h3 class="text-center">Voertuigen zonder inkoopfactuur/betaling</h3>
    <Loading v-if="loading" />
    <table v-else :class="`w-100 table__border--${styling_bu}`">
        <thead :class="`table__head--${styling_bu}`">
            <tr>
                <th class="table__head--text" style="width: 100px;">Foto</th>
                <th class="table__head--text">Item</th>
                <th class="table__head--text">Leverancier</th>
                <th class="table__head--text">Inkoper</th>
                <th class="table__head--text">Status</th>
                <th class="table__head--text">Ontvangstdatum</th>
                <th class="table__head--text">Orderdatum</th>
                <th class="table__head--text">Inkoopbedrag</th>
                <th class="table__head--text">Consignatie</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="(item, key) in missing_purchase_invoices" :key="key">
                <td class="table__cell--default">
                    <img :src="`https://apps.kleyn.com:1919/prod/public/data/mainimage/${item.nummer}/thumb`" />
                </td>
                <td class="table__cell--default">
                    <ImageHover :itemnummer="item.nummer" :bu="item.bu" />
                    {{ item.soortnaam }}<br />
                    {{ item.merknaam }}
                </td>
                <td class="table__cell--default">
                    <router-link :to="{ name: 'leverancier', params: { id: item.leverancier } }">{{ item.leverancier }}</router-link><br />
                    {{ item.leveranciernaam }}

                </td>
                <td class="table__cell--default">{{ item.inkopernaam }}</td>
                <td class="table__cell--default text-center">
                    {{ item.status }}
                </td>
                <td class="table__cell--default table__data--right">
                    {{ item.ontvangstdatum }}
                </td>
                <td class="table__cell--default table__data--right">
                    {{ item.orderdatum }}
                </td>
                <td class="table__cell--default table__data--right">
                    € {{ item.inkoopbedrag }}
                </td>
                <td class="table__cell--default table__data--right">
                    {{ item.consignatie }}
                </td>
            </tr>
        </tbody>
    </table>
</div>
</template>

<script>
import request from "@/functions/request.js";
import Loading from "@/components/Loading.vue";
import ImageHover from "@/components/ImageHover.vue";

export default {
    components: {
        Loading,
        ImageHover
    },
    data: () => ({
        styling_bu: '200',
        missing_purchase_invoices: null,
        loading: true,
    }),
    created() {
        this.loading = true;
        this.getData();
    },
    methods: {
        getData() {
            request(`missing-purchase-invoices`, "GET").then(({
                missing_purchase_invoices
            }) => {
                this.missing_purchase_invoices = missing_purchase_invoices;
                this.loading = false;
            })
        }
    }
}
</script>
